"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._heading = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextArea = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextArea");

var _TextArea2 = _interopRequireDefault(_TextArea);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textInput = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1)
});
var PopUpicon = (0, _glamor.css)({
  width: (0, _css.unitRem)(2.66),
  height: "auto",
  display: "none"
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block"
}));
var nameEmails = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1),
  width: "17.5rem"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  marginRight: "1.5rem",
  width: "100%"
}));
var nameEmail = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  margin: "auto"
}, (0, _css.maxWidth)(_css.breakpoints.medium)({
  flexDirection: "column"
}));

var foot = (0, _glamor.css)(_css.clearfix, {
  display: "block",

  marginTop: (0, _css.unitRem)(2),
  textAlign: "right"
}, (0, _css.minWidth)(_css.breakpoints.medium)({}));

var submitButton = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  textAlign: "center",
  display: "block",
  "& button": {
    paddingLeft: (0, _css.unitRem)(2.5),
    paddingRight: (0, _css.unitRem)(2.5),
    fontSize: (0, _css.unitRem)(0.625)
  },
  "& a": {
    paddingLeft: (0, _css.unitRem)(2.5),
    paddingRight: (0, _css.unitRem)(2.5),
    fontSize: (0, _css.unitRem)(0.625)
  }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  marginLeft: (0, _css.unitRem)(1),
  display: "inline",
  marginTop: "unset",
  textAlign: "left"
}), (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  "& button": {
    fontSize: "1rem!important"
  },
  "& a": {
    fontSize: "1rem!important"
  }
}));

var hr = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2),
  marginBottom: (0, _css.unitRem)(2)
});
var title = (0, _glamor.css)(_fonts.H5, {
  marginTop: 0,
  marginBottom: (0, _css.unitRem)(1.25)
  // textAlign: 'center',
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  // textAlign: 'left',
  marginBottom: (0, _css.unitRem)(0.5)
}));

var description = (0, _glamor.css)(_fonts.p3, {
  color: _css.colors.gray
});
var _heading = exports._heading = (0, _glamor.css)({
  display: "block",
  position: "relative",
  paddingLeft: 0,
  paddingTop: 0
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block",
  position: "absolute",
  paddingTop: "1rem",
  paddingLeft: "1.5rem"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  paddingTop: "1.2rem"
}));

var ContactUsPopup = function ContactUsPopup(props) {
  return _react2.default.createElement(
    _Form2.default,
    {
      className: _SubmitArtPopup.popup,
      error: props.error,
      message: props.message,
      onSubmit: props.onSubmit,
      onChildRef: props.onChildRef
    },
    _react2.default.createElement(
      "div",
      { className: _SubmitArtPopup.header },
      _react2.default.createElement("img", { src: props.icon, alt: "", className: PopUpicon }),
      _react2.default.createElement(
        "div",
        { className: _SubmitArtPopup.heading },
        _react2.default.createElement(
          "h1",
          { className: title },
          props.title
        )
      )
    ),
    _react2.default.createElement(_Hr2.default, { className: hr }),
    _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: nameEmail },
        _react2.default.createElement(
          "div",
          { className: nameEmails },
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
            label: "Name",
            type: "text",
            placeholder: "Your Full Name",
            disabled: props.submitting,
            autoComplete: true
          }, props.nameInputProps))
        ),
        _react2.default.createElement(
          "div",
          { className: nameEmails },
          _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
            label: "Email",
            type: "email",
            placeholder: "Your Email Address",
            disabled: true,
            autoComplete: true
          }, props.emailInputProps))
        )
      ),
      _react2.default.createElement(
        "div",
        { className: textInput },
        _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
          label: "Subject",
          type: "text",
          placeholder: "Write your Subject",
          disabled: props.submitting,
          autoComplete: true
        }, props.subjectInputProps))
      ),
      _react2.default.createElement(
        "div",
        { className: textInput },
        _react2.default.createElement(_TextArea2.default, (0, _extends3.default)({
          label: "Message",
          type: "text",
          placeholder: "Write your message here...",
          disabled: props.submitting
        }, props.commentsInputProps))
      ),
      _react2.default.createElement(_Hr2.default, { className: hr }),
      _react2.default.createElement(
        "div",
        { className: foot },
        _react2.default.createElement(_Button2.default, {
          type: "submit",
          className: submitButton,
          mode: "secondary",
          disabled: !!props.message,
          loading: props.submitting,
          label: "Send",
          small: true
        })
      )
    )
  );
};

exports.default = ContactUsPopup;


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUsContainer/ContactUsPopup.jsx
// module id = 2790
// module chunks = 0